import { Checkbox } from "@/components/ui/baseUi/checkbox"
import { cn } from "@/modules/lib/utils"
import { LightBoxOfferInfoEntity } from "@modules/boxOffer/entities/lightBoxOfferInfoEntity"
import { useBoxOffers } from "@modules/boxOffer/hooks/useBoxOffer"
import { CouponType } from "@modules/common/couponObject/gateway/couponObjectApiDto"
import { word } from "@modules/core/utils/i18n"
import { BoxOfferReductionItem } from "@modules/promoCode/components/boxOfferReductionItem"
import { Text } from "@/components/ui/baseUi/text"

export const BoxOfferListSelection: React.FC<{
  selectedBoxOfferIds: string[]
  onSelectBoxOffer: (id: string) => void
  onSelectAllBoxOffers: (allIds: string[]) => void
  promoCodeValue?: number
  promoCodeType?: CouponType
  promoCodeDuration?: number
  error?: React.JSX.Element
  className?: string
}> = ({
  selectedBoxOfferIds,
  onSelectBoxOffer,
  onSelectAllBoxOffers,
  promoCodeType,
  promoCodeValue,
  promoCodeDuration,
  error,
  className,
}) => {
  const { data: boxOffers } = useBoxOffers({ onlyWithPrice: true })

  return (
    <div className={cn("flex flex-col gap-2", className)}>
      <div className="mb-2 flex flex-row items-center justify-between">
        <Text fontStyle="LL">{word("global.filters.selectAll")}</Text>
        <Checkbox
          checked={boxOffers.length === selectedBoxOfferIds.length}
          onCheckedChange={() => onSelectAllBoxOffers(boxOffers.map((boxOffer) => boxOffer.id))}
          className="size-5"
        />
      </div>

      {boxOffers.map((boxOffer) => (
        <div key={boxOffer.id} className="flex flex-row items-center justify-between">
          <BoxOfferReductionItem
            key={boxOffer.id}
            boxOffer={boxOffer as LightBoxOfferInfoEntity}
            promoCodeType={promoCodeType}
            promoCodeValue={promoCodeValue}
            promoCodeDuration={promoCodeDuration}
          />
          <Checkbox
            className="size-5"
            value={boxOffer.id}
            checked={selectedBoxOfferIds.some((id) => id === boxOffer.id)}
            onCheckedChange={() => onSelectBoxOffer(boxOffer.id)}
            data-testid={boxOffer.id}
          />
        </div>
      ))}
      {error}
    </div>
  )
}
